import { useIntl } from '@leagueplatform/locales';
import { StepScreen } from 'components/step-screen/step-screen.component';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { useStepNavigation } from 'components/stepper/stepper.component';
import {
  useOnboardingFormActions,
  useOnboardingFormState,
} from 'components/onboarding-account-setup/contexts/onboarding-form.context';
import { PersonalInformationInput } from './personal-information-input.component';

export const PersonalInformationStep = () => {
  const { formatMessage } = useIntl();
  const { goToNextStep } = useStepNavigation();
  const {
    formState: { personalInformation, personalInformationErrors },
    setUserProfileStatus: { isPending },
  } = useOnboardingFormState();
  const { handlePersonalInformationChange, validatePersonalInformation } =
    useOnboardingFormActions();

  const handleSubmit = () => {
    if (validatePersonalInformation()) goToNextStep();
  };

  return (
    <StepScreen
      heading={formatMessage({
        id: STEP_STRING_IDS.personalInformation.heading,
      })}
      subHeading={formatMessage({
        id: STEP_STRING_IDS.personalInformation.subHeading,
      })}
      primaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.personalInformation.primaryButtonLabel,
        }),
        onClick: handleSubmit,
        isButtonLoading: isPending,
      }}
    >
      <PersonalInformationInput
        onChange={handlePersonalInformationChange}
        value={personalInformation}
        errors={personalInformationErrors}
      />
    </StepScreen>
  );
};
